// extracted by mini-css-extract-plugin
export var dropdownButton = "_24-0";
export var fullWidthDropdownButton = "_24-1";
export var icon = "_24-3";
export var iconPlaceholder = "_24-2";
export var menuItemRow = "_24-8";
export var separator = "_24-c";
export var shortcutContainer = "_24-7";
export var shortcutIconLg = "_24-6";
export var shortcutIconMd = "_24-5";
export var shortcutIconSm = "_24-4";
export var submenuChevron = "_24-b";
export var submenuDropdown = "_24-9";
export var submenuTriggerRow = "_24-a";